import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/users/user36.jpg'
import _imports_1 from '@/assets/images/users/user37.jpg'
import _imports_2 from '@/assets/images/users/user38.jpg'
import _imports_3 from '@/assets/images/users/user39.jpg'
import _imports_4 from '@/assets/images/users/user40.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex sm:items-center sm:justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle flex items-center mt-[15px] sm:mt-0" }
const _hoisted_4 = { class: "trezo-card-dropdown relative ltr:-mr-[7px] rtl:-ml-[7px]" }
const _hoisted_5 = {
  class: "trezo-card-content -mx-[20px] md:-mx-[25px]",
  id: "dataTable"
}
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_10 = { class: "flex items-center gap-[9px]" }
const _hoisted_11 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_12 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_13 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_14 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_15 = { class: "flex items-center gap-[9px]" }
const _hoisted_16 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_17 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_18 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_19 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_20 = { class: "flex items-center gap-[9px]" }
const _hoisted_21 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_22 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_23 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_24 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_25 = { class: "flex items-center gap-[9px]" }
const _hoisted_26 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_27 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_28 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "flex items-center gap-[9px]" }
const _hoisted_31 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_32 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_33 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0 font-semibold" }, "Employee List")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("form", { class: "relative w-[225px] sm:w-[265px] ltr:mr-[10px] rtl:ml-[10px] ltr:sm:mr-[15px] rtl:sm:ml-[15px]" }, [
          _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ]),
          _createElementVNode("input", {
            type: "text",
            placeholder: "Search for a name....",
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400",
            id: "dataTableSearchInput"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all text-[22px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "ri-more-2-fill" }, null, -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Day </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Week </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Month </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Year </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[55] || (_cache[55] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "id"
              }, [
                _createTextVNode(" ID "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "employee"
              }, [
                _createTextVNode(" Employee "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "department"
              }, [
                _createTextVNode(" Department "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "position"
              }, [
                _createTextVNode(" Position "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "joiningDate"
              }, [
                _createTextVNode(" Joining Date "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "salary"
              }, [
                _createTextVNode(" Salary "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "status"
              }, [
                _createTextVNode(" Status "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ]),
              _createElementVNode("th", {
                class: "font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative",
                "data-column": "action"
              }, [
                _createTextVNode(" Action "),
                _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" })
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " EMP001 ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-medium inline-block mb-px" }, " Olivia Turner "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " olivia@gmail.com ")
                  ])
                ])
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Marketing ", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Marketing Lead ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Jan 15, 2020 ", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $85,000 ", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block font-medium bg-success-100 dark:bg-[#15203c] text-success-700 rounded-sm text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, _cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " EMP002 ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-medium inline-block mb-px" }, " Liam Bennett "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " liam@gmail.com ")
                  ])
                ])
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Human Resources ", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " HR Manager ", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Mar 10, 2021 ", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $75,000 ", -1)),
              _cache[24] || (_cache[24] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block font-medium bg-purple-100 dark:bg-[#15203c] text-purple-700 rounded-sm text-xs" }, " On Leave ")
              ], -1)),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_16, _cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_17, _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_18, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[28] || (_cache[28] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " EMP003 ", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-medium inline-block mb-px" }, " Sophia Myers "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " sophia@gmail.com ")
                  ])
                ])
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " IT ", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Software Engineer ", -1)),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Feb 22, 2019 ", -1)),
              _cache[33] || (_cache[33] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $95,000 ", -1)),
              _cache[34] || (_cache[34] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block font-medium bg-success-100 dark:bg-[#15203c] text-success-700 rounded-sm text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_21, _cache[25] || (_cache[25] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_22, _cache[26] || (_cache[26] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_23, _cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[38] || (_cache[38] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " EMP004 ", -1)),
              _cache[39] || (_cache[39] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-medium inline-block mb-px" }, " Ethan Collins "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " ethan@gmail.com ")
                  ])
                ])
              ], -1)),
              _cache[40] || (_cache[40] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Sales ", -1)),
              _cache[41] || (_cache[41] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Sales Manager ", -1)),
              _cache[42] || (_cache[42] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Apr 12, 2022 ", -1)),
              _cache[43] || (_cache[43] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $90,000 ", -1)),
              _cache[44] || (_cache[44] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block font-medium bg-success-100 dark:bg-[#15203c] text-success-700 rounded-sm text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_26, _cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_27, _cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_28, _cache[37] || (_cache[37] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[48] || (_cache[48] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " EMP005 ", -1)),
              _cache[49] || (_cache[49] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-medium inline-block mb-px" }, " Isabella Reed "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " isabella@gmail.com ")
                  ])
                ])
              ], -1)),
              _cache[50] || (_cache[50] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Finance ", -1)),
              _cache[51] || (_cache[51] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Financial Analyst ", -1)),
              _cache[52] || (_cache[52] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Aug 05, 2020 ", -1)),
              _cache[53] || (_cache[53] = _createElementVNode("td", { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $80,000 ", -1)),
              _cache[54] || (_cache[54] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block font-medium bg-danger-100 dark:bg-[#15203c] text-danger-700 rounded-sm text-xs" }, " Resigned ")
              ], -1)),
              _createElementVNode("td", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_31, _cache[45] || (_cache[45] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_32, _cache[46] || (_cache[46] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_33, _cache[47] || (_cache[47] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[56] || (_cache[56] = _createElementVNode("div", {
        id: "noResultsMessage",
        class: "hidden my-[10px] px-[20px] md:px-[25px]"
      }, " No results found. ", -1)),
      _createVNode(_component_Pagination, {
        items: "4",
        total: "36",
        class: "px-[20px] md:px-[25px]"
      })
    ])
  ]))
}